import type { ReactNode } from 'react'

/** A labeled content section with an optional trailing action (e.g. "See all"). */
export function Section({
  label,
  action,
  children,
  className,
}: {
  label?: string
  action?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <section className={`section${className ? ` ${className}` : ''}`}>
      {(label || action) && (
        <header className="section__head">
          {label && <h2 className="label">{label}</h2>}
          {action}
        </header>
      )}
      {children}
    </section>
  )
}
